import { z } from 'zod'

export const ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'application/msword', // .doc
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
]
// const genderSchema = z.object({
//   descId: z.string().min(1, "Gender is required"),
//   desc: z.string(),
// }).nullable().refine(val => val !== null, {
//   message: "Gender is required"
// });

export const formSchema = z.object({
  // Personal Details
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  address: z.string().min(1, 'Address is required'),
  gender_name: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' }),
  gender: z.any(),
  dob: z.date({ required_error: 'Date of birth is required' }),

  contact_number: z.string().min(1, 'Contact number is required'),

  // Educational Background
  university: z.string().min(1, 'university is required'),
  degree_program: z.string().min(1, 'Institution name is required'),
  major: z.string().min(1, 'Program is required'),
  duration: z.string().min(1, 'duration is required'),
  //  graduation: z.string().min(1, 'Year of study is required'),

  year_of_study: z.any(),
  year_of_study_other: z.string().optional(),

  cgpa: z.string().min(1, 'Performance is required'),

  // Internship Preferences

  interests: z
    .array(z.object({ name: z.string() }))
    .min(1, 'Area of interest is required')
    .transform((arr) => arr.map((item) => item.name)),

  interests_other: z.string().optional(),
  start_date: z.date({ required_error: 'Date of birth is required' }),

  // Experience and Skills
  skills: z.string().min(1, 'Proficiency is required'),
  resume: z
    .custom<File>((file) => file instanceof File, {
      message: 'Resume is required',
    })
    .refine((file) => ACCEPTED_FILE_TYPES.includes(file.type), {
      message: 'Only .pdf, .doc, and .docx files are accepted',
    }),

  // Motivation & Goals
  why_interested: z.string().min(1, 'This field is required'),
})

export type AdminSchema = z.infer<typeof formSchema>
